import { memo } from "react";
import { HighlightedCode } from "./HighlightedCode";

interface CodeBlockProps {
  code: string;
  language: string;
}

// Fenced code block for chat markdown: legacy-style muted background with no
// border, tight line-height, and a copy button revealed on hover.
export const CodeBlock = memo(function CodeBlock({ code, language }: CodeBlockProps) {
  return (
    <HighlightedCode
      code={code}
      language={language}
      wrapperClassName="my-3 first:mt-0 last:mb-0"
      className="overflow-x-auto rounded-lg bg-muted px-4 py-3 pr-10 text-[0.8125rem] leading-5"
      copyOnHoverOnly
    />
  );
});
